import { fromJS } from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const registrationState = fromJS({
  terms: false,
  access_code: '',
  access_code_type: 'premium',
  first_name: '',
  last_name: '',
  email: '',
  zip: '',
  phone_number: '',
  gender: '',
  password: '',
  permissions: {
    eligibility: false,
    research: false,
    emergency: true,
    substitute: true 
  },
  preferences: {
    email: true,
    phone: false,
    share: true
  },
  site: {}
});

function setState(state, newState) {
  return state.merge(newState);
}

export default function registration(state = registrationState, action) {
  switch(action.type) {
    case ActionTypes.UPDATE_PROPERTY:
      return setState(state, state.set(action.payload.label, action.payload.value));

    case ActionTypes.UPDATE_NESTED_PROPERTY:
      return setState(state, state.setIn(action.payload.path, action.payload.value));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/registration.js